import React from 'react'
import { TextField } from 'react-admin'
import MainProductList, {
  MainProductListProps,
} from 'ui-shared/WrappedInputs/MainProductList'

const EventPackageList: React.FC<MainProductListProps> = (props) => (
  <MainProductList {...props}>
    <TextField source="status" sortable={false} />
  </MainProductList>
)

export default EventPackageList
